module.exports = __webpack_public_path__ + "static/media/InvoiceCreateDLD.92e0236f.png";